// extracted by mini-css-extract-plugin
export var footer = "_oa-5";
export var fulfillmentInput = "_oa-0";
export var shipDateInput = "_oa-1";
export var shipmentModal = "_oa-2";
export var shipmentModalContent = "_oa-3";
export var tableContainer = "_oa-4";